module.exports = __webpack_public_path__ + "user-placeholder.fd4b3910137a5cbcbd834121d24f1877.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/Avatar/img/user-placeholder.svg
// module id = 1428
// module chunks = 8